import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ScreenService} from '@app/core';
import {Actions, AnalyticOperation, ServiceOrder} from '@app/shared';

@Component({
  selector: 'app-collapse-panel-header',
  standalone: false,

  templateUrl: './collapse-panel-header.component.html',
  styleUrl: './collapse-panel-header.component.less'
})
export class CollapsePanelHeaderComponent {

  @Input() id: number = 0;
  @Input() code: string | undefined;
  @Input() name: string | undefined;
  @Input() titleFontSize: string = '16px';
  @Input() date: string | undefined;
  @Input() state: string | undefined;
  @Input() showStateBadge: boolean = true;
  @Input() panelActive: boolean = false; // Cuando esta expandido
  @Input() actions: Actions = {copy: true, file: true, message: true, drawer: true, select: false};
  @Input() selectList:string[]=[];
  @Input() onlyText: string | undefined;
  @Input() isWarning: boolean = false;
  @Input() hideArrow: boolean = false;
  @Input() minHeight: string = '70px';
  @Input() soAndAoCollapse: AnalyticOperation[] | undefined;
  @Input() isIngreso: boolean | undefined;
  @Input() emptyMessage: string | undefined;

  @Output() actionEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() navigationEvent: EventEmitter<void> = new EventEmitter<void>();

  isMobile$;

  constructor(private screenService: ScreenService) {
    this.isMobile$ = this.screenService.isMobile$;
  }


  onAction(action: string): void {
    this.actionEvent.emit(action);
  }

}
